import { Grid } from '@change/ds-layout';

import { RecentSupporters } from './components/EngageSupporters/components/RecentSupporters';
import { PetitionOverview } from './components/PetitionOverview';

export function PageBody() {
	return (
		<Grid className="py-4 lg:py-6">
			{/* TODO: Adjust the col span properties once we have the hi-fi designs. */}
			<div className="sm:hidden md:col-span-2 md:block lg:col-span-3">Side Navigation</div>
			<div className="col-span-4 w-full md:col-span-6 lg:col-span-9">
				{/* This is where modules will be referenced e.g. <PetitionOverview /> */}
				<PetitionOverview />
				<RecentSupporters />
			</div>
		</Grid>
	);
}
